import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { updateBrokerConnectData } from '@actions/brokerConnect/brokerConnectActionCreators';
import { configs } from '@constants/configs/configs';

//components
import InputPhoneNumber from './components/InputPhoneNumber';
import Alert from './Alert';
import ErrorMessage from './components/ErrorMessage';

import { ACTIVITY_TYPES } from '@constants/common/statusTypes';
import { IEX_STATE_CODES } from '@constants/configs/states';

const Participation = props => {

    const { brokerInfo, actions, environment: { stateCode, isState } } = props;
    const isStateVA = isState.VA; 
    const { status, phoneNumber, tempPhoneNumber=null } = brokerInfo;
    const { endpoints, routes } = configs;

    const navigate = useNavigate();

    const [ isChecked, setChecked ] = useState(false);
    const [ showErrorMessage, setErrorMessage ] = useState(false);
    const [ showSuccessMessage, setSuccessMessage ] = useState(false);
    const [ showPhoneErrorMessage, setPhoneErrorMessage ] = useState(false);
    const [ currentStatus, setCurrentStatus ] = useState(status);
    const hideEnrollmentChoiceCheckbox = (isStateVA && currentStatus !== ACTIVITY_TYPES.ACTIVE);
    useEffect( ()=> {
        setCurrentStatus(status);
    }, [status]);
    
    const validNumber = () => {

        if( (phoneNumber && phoneNumber.length === 10 && tempPhoneNumber === null ) || tempPhoneNumber && tempPhoneNumber.length === 10 ) {
            return true;
        } else {
            return false;
        }
    };

    const isValidated = (validNumber() && isChecked) || (validNumber() && !isChecked && hideEnrollmentChoiceCheckbox);
  
    const handleSubmit = (e) => {  
        e.preventDefault();
       
        if(!validNumber()) {
            setPhoneErrorMessage(true);
        }

        if (!isChecked && !hideEnrollmentChoiceCheckbox) {
            setErrorMessage(true);
        }

        if (isValidated) {
            const updateStatus = currentStatus === ACTIVITY_TYPES.ACTIVE ? ACTIVITY_TYPES.INACTIVE : ACTIVITY_TYPES.ACTIVE;
            setCurrentStatus(updateStatus);
            setErrorMessage(false);
            setChecked(false);

            tempPhoneNumber === null ?
                actions.updateBrokerConnectData(endpoints.BROKERCONNECT_PARTICIPATION_DETAILS, { ...brokerInfo, status: updateStatus })
                :
                actions.updateBrokerConnectData(endpoints.BROKERCONNECT_PARTICIPATION_DETAILS, { ...brokerInfo, status: updateStatus, phoneNumber: tempPhoneNumber });

            switch (updateStatus) {
                case ACTIVITY_TYPES.ACTIVE:
                    //add slight delay to redirect
                    setTimeout(() => {
                        navigate(routes.BROKER_CONNECT_AVAILABILITY, { redirectedFromParticipation: true });
                    }, 300);
                    break;
                case ACTIVITY_TYPES.INACTIVE:
                    setSuccessMessage(true);
                    break;
            }
        }
    };

    const clearErrorMessage = () => {
        showPhoneErrorMessage ? setPhoneErrorMessage(false) : null;
    };

    const getLink = () => {
        return endpoints?.externalUrls?.brokerConnectParticipationAgreement?.[stateCode] ?? '#';
    };

    const brokerConnectParticipation = () => {
        if (currentStatus === ACTIVITY_TYPES.ACTIVE) {
            return (<FormattedMessage id='brokerconnect.participation.msg.remove' />);
        } else {
            if (hideEnrollmentChoiceCheckbox) {
                return null;
            } else {
                return (<FormattedMessage
                    id='brokerconnect.participation.msg.agreement'
                    values={{ link: <a href={getLink()} target='_blank' rel="noopener noreferrer" > <FormattedMessage id='brokerconnect.participation.msg.agreement_link' /></a> }}
                />);
            }
        }
    };
       
    return(
        <div className="participation-container">
            <div className="grid-container gi-panel" id="main-content">
                {
                    showSuccessMessage ?
                        <Alert
                            header="brokerconnect.participation.error_msg.successfully_unenrolled.header"
                            message="brokerconnect.participation.error_msg.successfully_unenrolled.message"
                            variation="success"
                        />
                        :
                        null
                }
                <div className="header">
                    <h4 className="heading">
                        <FormattedMessage
                            id='brokerconnect.participation.header'
                        />
                    </h4>
                </div>
                <div className="padding-105">
                    <div className="grid-row">
                        {
                            currentStatus === ACTIVITY_TYPES.ACTIVE ?
                                <p className="">
                                    <FormattedMessage
                                        id='brokerconnect.participation.msg.currently_enrolled'
                                    />
                                </p>
                                :
                                <div>
                                    <p>
                                        <FormattedMessage
                                            id='brokerconnect.participation.msg.description'
                                        />
                                    </p>
                                    <p>
                                        <FormattedMessage
                                            id='brokerconnect.participation.msg.provide_number'
                                        />
                                    </p>
                                    <div className="gi-component">
                                        <label className="gi-regular_input__label" htmlFor="brokerConnectPhone">
                                            <FormattedMessage
                                                id='brokerconnect.participation.msg.phone_number'
                                            />
                                        </label>
                                        <InputPhoneNumber id="brokerConnectPhone" { ...brokerInfo }  errorHandler={ clearErrorMessage } />
                                        {
                                            showPhoneErrorMessage && <ErrorMessage message='brokerconnect.error_msg.invalid_phonenumber' />
                                        }
                                    </div>
                                    <p>
                                        <FormattedMessage
                                            id='brokerconnect.participation.msg.note_phone_number'
                                        />
                                    </p>
                                </div>
                        }
                    </div>
                    <form id="participation-form" className="" onSubmit={ handleSubmit }>
                        <div className="gi-component gi-checkbox">
                            {!hideEnrollmentChoiceCheckbox && (<input id="enrollmentChoiceCheckbox" className="usa-checkbox__input gi-checkbox__input" type="checkbox" onChange={() => setChecked(!isChecked)} checked={isChecked} />)}
                            {!hideEnrollmentChoiceCheckbox && (<label className="usa-checkbox__label gi-checkbox__label" htmlFor="enrollmentChoiceCheckbox">
                                {brokerConnectParticipation()}
                            </label>)}
                        </div>
                        <div className="">
                            { showErrorMessage && !isChecked && <ErrorMessage message="brokerconnect.participation.error_msg.checkbox_agree_to_terms" /> }
                        </div>
                        <div className="controls-container">
                            <div className="grid-row controls">
                                <div className="grid-col-12 buttons-group txt-right">
                                    <button className="usa-button gi-button gi-button__primary" type="submit">
                                        {
                                            currentStatus === ACTIVITY_TYPES.ACTIVE ?
                                                <FormattedMessage id='brokerconnect.participation.remove_btn' />
                                                :
                                                <FormattedMessage id='brokerconnect.participation.confirm_btn' />
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    brokerInfo: state.brokerConnect,
    environment: state.common.environment
});


const matchDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        updateBrokerConnectData
    }, dispatch)
});

export default connect(mapStateToProps, matchDispatchToProps)(Participation);